import { render, staticRenderFns } from "./players.vue?vue&type=template&id=23658376&scoped=true"
import script from "./players.vue?vue&type=script&lang=js"
export * from "./players.vue?vue&type=script&lang=js"
import style0 from "./players.vue?vue&type=style&index=0&id=23658376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23658376",
  null
  
)

export default component.exports